class SliderBanner extends HTMLElement {
  constructor() {
    super()
    this.swiper = null
  }

  connectedCallback() {
    if (typeof Swiper === 'undefined') {
      console.warn('Swiper is not loaded')
      return
    }

    const sectionId = this.dataset.sectionId
    const swiperElem = this.querySelector(`#slider-banner-${sectionId}`)

    if (!swiperElem) return

    const allowMousewheel = this.dataset.allowMousewheel === 'true'
    const allowAutoplay = this.dataset.allowAutoplay === 'true'
    const playInLoop = this.dataset.playInLoop === 'true'

    const autoplayDelay = parseInt(this.dataset.autoplayDelay || '2500', 10)
    const autoplayDisableOnInteraction =
      this.dataset.autoplayDisableOnInteraction === 'true'

    let autoplay = undefined
    if (allowAutoplay) {
      autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: autoplayDisableOnInteraction,
      }
    }

    this.swiper = new Swiper(swiperElem, {
      mousewheel: allowMousewheel,
      autoplay,
      loop: playInLoop,
      slidesPerView: 1,
      autoHeight: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    })
  }

  disconnectedCallback() {
    if (this.swiper && typeof this.swiper.destroy === 'function') {
      this.swiper.destroy(true, true)
    }
  }
}

customElements.define('slider-banner', SliderBanner)
